<template>
    <section class="service-area fix section-padding bg-cover pb-0 section" id="service" :style="bgImg">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="section-title title-style-5 text-center">
                        <h2 class="title">Sherbimet</h2>
                        <p class="paragraph">Ne ofrojme nje game te gjere te analizave te gjakut dhe jo vetem.</p>
                    </div>
                </div>
            </div>
            <div class="row service-item-inner">
                <!-- service single item start -->
                <div class="col-lg-4 col-md-6">
                    <div v-for="(service, services) in services" :key="services" class="service-item service-item__left">
                        <div class="service-icon">
                            <img :src="service.icon" alt="service icon">
                        </div>
                        <div class="service-content">
                            <h6>{{ service.title }}</h6>
                            <p>{{ service.desc }}</p>
                        </div>
                    </div>
                </div>
                <!-- service single item start -->

                <!-- service thumb start -->
                <div class="col-lg-4 order-3 order-lg-2">
                    <div class="service-middle-thumb">
                        <img src="../assets/img/home-medical/service.jpg" alt="service thumb">
                    </div>
                </div>
                <!-- service thumb  -->

                <!-- service single item start -->
                <div class="col-lg-4 col-md-6 order-2 order-lg-3">
                    <div v-for="(service2, services2) in services2" :key="services2" class="service-item service-item__right">
                        <div class="service-icon">
                            <img :src="service2.icon" alt="service icon">
                        </div>
                        <div class="service-content">
                            <h6>{{ service2.title }}</h6>
                            <p>{{ service2.desc }}</p>
                        </div>
                    </div>
                </div>
                <!-- service single item start -->
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'Service',
         metaInfo:{
            title: 'Analiza Biokimike, Analiza Hormonale, Analiza Hematologjike, Analiaza Imunologjike', 
        },
        data () {
            return {
                bgImg: {
                    backgroundImage: `url(${require('../assets/img/home-medical/service-bg.jpg')})`
                },
                services: [
                    {
                        title:"Analiza Biokimike", 
                        desc:"Analiza Biokimike është një metodë thelbësore e diagnozës laboratorike të sëmundjeve të ndryshme.",  
                        icon: require("../assets/img/home-medical/service/1.png")
                    },
                    {
                        title:"Analiza Hormonale", 
                        desc:"Analiza Hormonale kryhet për të përcaktuar nivelin e hormoneve luteinizing, progesterone, etj.",  
                        icon: require("../assets/img/home-medical/service/icon2.png")
                    },
                    {
                        title:"Analiza Hematologjike", 
                        desc:"Kjo Analizë vlerëson statistikisht ndryshimet hematologjike si një provë diagnostike për malarien në pacientët me sëmundje akute febrile.",  
                        icon: require("../assets/img/home-medical/service/3.png")
                    },
                ],
                services2: [
                    {
                        title:"Analiaza Imunologjike", 
                        desc:"Teknikat imunologjike janë varietetet e gjerë të metodave dhe protokolleve të specializuara.",  
                        icon: require("../assets/img/home-medical/service/4.png")
                    },
                    {
                        title:"Analiza Mikrobiologjike dhe Infeksionet", 
                        desc:"Analizat e mëposhtme kryhen në laboratorin mikrobiologjik, duke përdorur teknikat standarde mikrobiologjike.",  
                        icon: require("../assets/img/home-medical/service/icon1.png")
                    },
                    {
                        title:"Ne Shtatzeni", 
                        desc:"Kontrollet gjate fazes se shtatzenise jane te domosdoshme pasi monitorojne shendetin e nenes dhe njekohsisht edhe andamentin e embrionit/foshnjes.",  
                        icon: require("../assets/img/home-medical/service/6.png")
                    },
                ]
            }
        }
    }
</script>

<style lang='scss'>
    @import '../assets/scss/variables.scss';
    @import '../assets/scss/components/service.scss';
</style>
